/* Delivery block: fixed delivery times (Theme settings → Delivery times),
   counted in UK working days from today. Nothing is looked up and nothing is
   asked of the shopper; changing country simply shows that country's dates. */
(function () {
  const post = (u, b) => fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(b) });

  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.result = this.querySelector('[data-result]');
      if (!this.result) return;
      this.country = (this.dataset.country || 'GB').toUpperCase();
      this.countryWrap = this.querySelector('[data-country-wrap]');
      this.countrySelect = this.querySelector('[data-country-select]');
      const fields = this.querySelector('[data-fields]');
      if (fields) fields.hidden = true;

      this.querySelector('[data-change]')?.addEventListener('click', () => {
        if (!this.countryWrap) return;
        const open = this.countryWrap.hidden;
        this.countryWrap.hidden = !open;
        if (open) this.countrySelect?.focus();
      });
      this.countrySelect?.addEventListener('change', () => {
        this.setCountry(this.countrySelect.value);
        if (this.countryWrap) this.countryWrap.hidden = true;
        try { sessionStorage.setItem('delivery-country', this.country); } catch (e) {}
        this.render();
      });
      try {
        const saved = sessionStorage.getItem('delivery-country');
        if (saved && this.countrySelect?.querySelector(`option[value="${saved}"]`)) {
          this.countrySelect.value = saved;
          this.setCountry(saved);
        }
      } catch (e) {}

      // An older version of this block emptied the cart briefly to check rates.
      // If a shopper left mid-check, put their cart back.
      try { const p = localStorage.getItem('delivery-check-cart'); if (p) this.restoreCart(JSON.parse(p)); } catch (e) {}
      this.render();
    }

    setCountry(code) {
      this.country = String(code || 'GB').toUpperCase();
      const name = this.countrySelect?.selectedOptions[0]?.dataset.name || '';
      const label = this.querySelector('[data-country-label]');
      if (label && name) label.textContent = name;
    }

    async restoreCart(snap) {
      try {
        await post('/cart/clear.js', {});
        if (snap.items.length) await post('/cart/add.js', { items: snap.items.map((i) => ({ id: i.variant_id, quantity: i.quantity, properties: i.properties || {}, selling_plan: i.selling_plan_allocation?.selling_plan?.id })) });
        if (snap.note || (snap.attributes && Object.keys(snap.attributes).length)) await post('/cart/update.js', { note: snap.note || '', attributes: snap.attributes || {} });
        localStorage.removeItem('delivery-check-cart');
      } catch (e) {}
    }

    /* England and Wales bank holidays, for any year */
    hols(y) {
      const H = this.H || (this.H = {}); if (H[y]) return H[y];
      const D = (m, d) => new Date(y, m, d, 12), k = (d) => d.toDateString();
      const mon = (d, s) => { while (d.getDay() !== 1) d.setDate(d.getDate() + s); return d; };
      const a = y % 19, b = (y / 100) | 0, c = y % 100, h = (19 * a + b - ((b / 4) | 0) - (((8 * b + 13) / 25) | 0) + 15) % 30;
      const l = (32 + 2 * (b % 4) + 2 * ((c / 4) | 0) - h - (c % 4)) % 7, m = ((a + 11 * h + 22 * l) / 451) | 0, n = h + l - 7 * m + 114;
      const e = D(((n / 31) | 0) - 1, (n % 31) + 1), gf = new Date(e), em = new Date(e);
      gf.setDate(e.getDate() - 2); em.setDate(e.getDate() + 1);
      const s = new Set([k(gf), k(em), k(mon(D(4, 1), 1)), k(mon(D(5, 0), -1)), k(mon(D(8, 0), -1))]);
      [D(0, 1), D(11, 25), D(11, 26)].forEach((d) => { while (d.getDay() % 6 === 0 || s.has(k(d))) d.setDate(d.getDate() + 1); s.add(k(d)); });
      return (H[y] = s);
    }
    working(d) { return d.getDay() % 6 !== 0 && !this.hols(d.getFullYear()).has(d.toDateString()); }
    biz(n) { const d = new Date(); d.setHours(12, 0, 0, 0); for (let a = 0; a < n;) { d.setDate(d.getDate() + 1); if (this.working(d)) a++; } return d; }
    fmt(d) { return d.toLocaleDateString(document.documentElement.lang || 'en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }

    /* Made to order everywhere; otherwise UK or every other country */
    days() {
      const pick = this.dataset.daysMto || (this.country === 'GB' ? this.dataset.daysUk : this.dataset.daysIntl) || '';
      const [lo, hi] = pick.split(',').map((n) => parseInt(n, 10));
      if (isNaN(lo)) return null;
      return [lo, Math.max(lo, isNaN(hi) ? lo : hi)];
    }

    render() {
      const set = this.days();
      if (!set) { this.result.innerHTML = `<p class="delivery__status">${this.dataset.noRatesText || ''}</p>`; return; }
      const f = this.fmt(this.biz(set[0])), t = this.fmt(this.biz(set[1]));
      const w = this.dataset.arrivesText ?? 'Arrives';
      const when = `${w ? w + ' ' : ''}${f === t ? f : `${f} – ${t}`}`;
      const name = this.dataset.rateName || 'Standard delivery';
      this.result.innerHTML = '';
      const row = document.createElement('div');
      row.className = 'delivery__rate';
      row.innerHTML = '<span class="delivery__name"></span><span class="delivery__when"></span>';
      row.children[0].textContent = name;
      row.children[1].textContent = when;
      this.result.append(row);
    }
  }
  if (!customElements.get('delivery-estimate')) customElements.define('delivery-estimate', DeliveryEstimate);
})();
